module.exports = __webpack_public_path__ + "static/media/logoorange.40341f54.png";